import React, { useEffect, useState } from "react";
import { useLang } from "../contexts/LanguageContext";
import api from "../lib/api";
import { ArrowUpRight } from "lucide-react";

export default function ServicesPage() {
  const { t, lang } = useLang();
  const [services, setServices] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/services").then((r) => {
      setServices(r.data);
      const hash = window.location.hash.replace("#", "");
      if (hash) setActive(hash);
      else if (r.data[0]) setActive(r.data[0].slug);
    }).catch(() => {});
  }, []);

  const current = services.find((s) => s.slug === active);

  return (
    <div data-testid="services-page" className="pt-40 lg:pt-44">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        <div className="overline text-[#4A6A8F]">{t.services.eyebrow}</div>
        <h1 className="font-serif-ap text-5xl sm:text-6xl lg:text-7xl text-[#0F2746] mt-6 max-w-4xl leading-[1.02] tracking-tight">
          {t.services.title}
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-4">
            <ul className="border-t border-[#0F2746]/15">
              {services.map((s, idx) => (
                <li key={s.id} className="border-b border-[#0F2746]/15">
                  <button
                    data-testid={`service-tab-${s.slug}`}
                    onClick={() => { setActive(s.slug); window.history.replaceState(null, "", `#${s.slug}`); }}
                    className={`w-full text-left py-5 flex items-baseline gap-5 group transition-colors ${
                      active === s.slug ? "text-[#0F2746]" : "text-[#3A5170] hover:text-[#0F2746]"
                    }`}
                  >
                    <span className="font-serif-ap text-base text-[#C4A47C] w-8">{String(idx + 1).padStart(2, "0")}</span>
                    <span className="font-serif-ap text-xl lg:text-2xl flex-1 leading-tight">
                      {lang === "tr" ? s.title_tr : s.title_en}
                    </span>
                    {active === s.slug && <ArrowUpRight size={16} className="text-[#C4A47C]" />}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <div className="lg:col-span-8 lg:pl-12 lg:border-l lg:border-[#0F2746]/10">
            {current ? (
              <div data-testid="service-detail" className="ap-rise">
                <div className="overline text-[#4A6A8F]">
                  {String(services.findIndex((s) => s.slug === current.slug) + 1).padStart(2, "0")}
                </div>
                <h2 className="font-serif-ap text-4xl lg:text-6xl text-[#0F2746] mt-4 leading-[1.05]">
                  {lang === "tr" ? current.title_tr : current.title_en}
                </h2>
                <div className="h-[1px] w-16 bg-[#C4A47C] my-10" />
                <p className="text-[#0F2746] text-lg leading-relaxed">
                  {lang === "tr" ? current.summary_tr : current.summary_en}
                </p>
                {(lang === "tr" ? current.description_tr : current.description_en) && (
                  <p className="text-[#3A5170] text-base leading-relaxed mt-6 whitespace-pre-line">
                    {lang === "tr" ? current.description_tr : current.description_en}
                  </p>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </section>
    </div>
  );
}
